import * as React from 'react';
export const AlertContext = React.createContext(null);
//# sourceMappingURL=AlertContext.js.map